import React from 'react';

const EditButtonRenderer = (props) => {
  const { setOpenEditModal, setSelectedRowForEdit  } = props;

  const handleClick = () => {
    const rowData = props.data;
    setOpenEditModal(true);
    setSelectedRowForEdit(rowData); 
    // You can do something like open a modal, set state, etc.
    console.log('Edit clicked:', rowData);
  };

  return (
    <button
      className='bg-blue-600 text-white px-1 rounded hover:bg-blue-700 transition m-2'
      onClick={handleClick}
    >
      Edit Request
    </button>
  );
};

export default EditButtonRenderer;
